// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import type { IAuthConfig } from 'ionic-appauth';

export const apiHost = 'https://newo-2-e2301afb1289.herokuapp.com/';

const oidcConfig: IAuthConfig = {
  client_id: 'PycEA6orqESYu9OwTHqOBZqXYY9SRZTI',
  server_host: 'https://dev-v3uslkezf3bvtoxp.us.auth0.com',
  redirect_url: window.location.origin + '/callback',
  end_session_redirect_url: window.location.origin + '/',
  scopes: 'openid profile',
  pkce: true,
};

const gqlConfig = {
  gqlUri: 'neo4j+s://0c41fb82.databases.neo4j.io',
  gqlPassword: '41EG6DJl1fz202ERZmLVlCeH3w914Ab7qEyykBsfIxQ',
};

const api_dashboard = {
  base_url:'https://newo2-desk-api-dev.azurewebsites.net'
  //base_url:'http://127.0.0.1:8000'
}

const wompi_make = {
  pago_url_tarjeta:'https://hook.us1.make.com/fc35ycv9lfble364jjp5l3i1u8fdbsec',
  card_link:'https://hook.us1.make.com/ele41guaqhd9o5rrd7wxin4gizpkl5xr',
  caed_boton:'https://hook.us1.make.com/hhefsaw8l5mu5d4xdl5q36vd1fh3hhcs'
}

export const environment = {
  production: true,
  apiUrl: `${apiHost}api`,
  /*hostifyUrl: 'https://api-rms.hostify.com/',*/
  hostifyUrl: 'https://newo2-api-managment.azure-api.net/hostify/',
  apiKey: 'juCtRMBn3OOJ0TKhQlsLhEXMCOCOKkSW',
  OcpApimSubscriptionKey: '154019ff0b5a49018164ee5d2253ab93',
  oidcConfig,
  gqlConfig,
  audience: 'https://dev-v3uslkezf3bvtoxp.us.auth0.com/api/v2/',
  scheme: 'newo2-desk.azurewebsites.net',
  api_dashboard: api_dashboard,
  wompi_make: wompi_make,
  // scheme: 'dev.localhost.ionic',
  firebase: {
    apiKey: 'AIzaSyC0qVRN0A2V3X61mSYKTvC4C5vCtf-Gh4o',
    authDomain: 'newo2-storage.firebaseapp.com',
    projectId: 'newo2-storage',
    storageBucket: 'newo2-storage.appspot.com',
    messagingSenderId: '100830090474',
    appId: '1:100830090474:web:52c735950aaabfd24d3393',
    measurementId: 'G-G57DJVKCNB',
  },
  // gqlUrl: 'https://nigran.stepzen.net/api/newo2/__graphql',
  gqlUrl: 'https://newo2-api-graphql.azurewebsites.net/graphql',
  paymentsUrl: 'https://newo2-payments-api-f5111d8ab193.herokuapp.com/',
  iaUrl: 'https://newo2-cypher-api-f7869b83e150.herokuapp.com/',
  // wompi sandbox
  public_test_wompi: 'pub_test_JjMmOAhuLR06FjGY8eWoc0mb4UtpVhOc',
  private_test_wompi: 'prv_test_fI7J847mD5TZ4147ibYo35glb1WZRpUC',
  integrity_test_wompi: 'test_integrity_w7XJo8QqFpiDv3EeWdP7X4FKuHqeuoqE',
  // wompi production
  public_prod_wompi: 'pub_prod_Ko00lqaWmhxfHdYAbJd3A2qNq2CoCAKp',
  private_prod_wompi: 'prv_prod_egv4N3BygLNK9ClY6xERZM7gabUutmQo',
  integrity_prod_wompi: 'prod_integrity_2EVJxm9bhrH5O61Vnwrpsy3aMF0Zbmfc',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
